import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { BannerLink } from "@src/appV2/lib/Alert";

export function AccountRestrictionBanner() {
  return (
    <BannerLink to={DeprecatedGlobalAppV1Paths.RATINGS_ATTENDANCE_SCORE} severity="warning">
      Your account is restricted. You may only book and work shifts at workplaces where you are a
      favorite worker.
    </BannerLink>
  );
}
